// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"d0623737","legalText":"e564802b"};